import * as Yup from "yup";
const GoogleMapSchema = Yup.object().shape({
  title: Yup.string().required().strict().trim(),
  embedded: Yup.string().strict().trim(),
  display_order: Yup.string().strict().trim(),
  status: Yup.string().oneOf(["active", "inactive"]).default("active"),
});
export default GoogleMapSchema;
